import { format } from "date-fns";
import { PAYMENT_FORM } from "../../utils/const";


const saveForm = (key: any, value: any) => {

  if (key === 'date') {
    value = format(value, 'yyyy-MM-dd HH:mm:ss')
  }

  return {
    type: PAYMENT_FORM,
    payload: { key, value }
  }
}

export default saveForm;
